import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import BadgeCard from './BadgeCard';
import ItemCard from './ItemCard';
import { Link } from 'react-router-dom';

const ResponsiveSlider = () => {
  const data = [
    {
        id: 1,
        image: "https://www.kfcpakistan.com/images/afc4e8b0-ff99-11ed-8640-872ee63b5da0-Krunch-2023-05-31095826.png",
        text: "Everyday Value",
        href: "/menu"
    },
    {
        id: 2,
        image: "https://www.kfcpakistan.com/images/afc4e8b0-ff99-11ed-8640-872ee63b5da0-Krunch-2023-05-31095826.png",
        text: "Ala-Carte-&-Combos",
        href: "/menu"
    },
    {
        id: 3,
        image: "https://www.kfcpakistan.com/images/afc4e8b0-ff99-11ed-8640-872ee63b5da0-Krunch-2023-05-31095826.png",
        text: "Promotion",
        href: "/menu"
    },
    {
        id: 4,
        image: "https://www.kfcpakistan.com/images/afc4e8b0-ff99-11ed-8640-872ee63b5da0-Krunch-2023-05-31095826.png",
        text: "Signature-Boxes",
        href: "/menu"
    },
    {
        id: 5,
        image: "https://www.kfcpakistan.com/images/afc4e8b0-ff99-11ed-8640-872ee63b5da0-Krunch-2023-05-31095826.png",
        text: "Sharing",
        href: "/menu"
    },
    {
        id: 6,
        image: "https://www.kfcpakistan.com/images/afc4e8b0-ff99-11ed-8640-872ee63b5da0-Krunch-2023-05-31095826.png",
        text: "Snacks-&-Beverages",
        href: "/menu"
    },
];

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 780,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div className=''>
      <Slider {...settings}>
        {data.map((data) => ( 
          <div className=''>       
            <div key={data.id} className='px-5 min-h-[230px] group hover:cursor-pointer flex sm:justify-center z-[-1]'>
          <Link to={data.href}>
        <div className="h-[220px] flex z-[10] mt-7  ">
          <BadgeCard data={data} />
        </div>
        </Link>
      </div>
      </div> 
              ))}
      </Slider>
    </div>
  );
};

export default ResponsiveSlider;
